var render, staticRenderFns
import script from "./groupItem.vue?vue&type=script&lang=js"
export * from "./groupItem.vue?vue&type=script&lang=js"
import style0 from "./groupItem.vue?vue&type=style&index=0&id=4d416be3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d416be3",
  null
  
)

export default component.exports